import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'registered-users-search',
  templateUrl: './registered-users-search.component.html',
  styleUrls: ['./registered-users-search.component.scss']
})
export class RegisteredUsersSearchComponent implements OnInit {

  onApply = new EventEmitter();

  constructor(public dialogRef: MatDialogRef<RegisteredUsersSearchComponent>, @Inject(MAT_DIALOG_DATA) public search: any) {
  }

  ngOnInit(): void {
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close();
    this.onApply.emit(this.search);
  }

}
